import { ContainerType, CurrencyCode } from '../types';

export const containerTypes: { label: string; value: ContainerType }[] = [
  { label: "20'DC", value: '20DC' },
  { label: "20'HC", value: '20HC' },
  { label: "40'DC", value: '40DC' },
  { label: "40'HC", value: '40HC' },
  { label: "45'HC", value: '45HC' },
];

export const containerStatues: { label: string; value: string }[] = [
  { label: 'Gated In', value: 'GATED_IN_NEW' },
  { label: 'In Depot', value: 'GATED_IN' },
];

export const containerConditionOptions = [
  { label: 'New', value: 'NEW' },
  { label: 'CW', value: 'CW' },
  { label: 'IICL', value: 'IICL' },
  { label: 'WWT', value: 'WWT' },
  { label: 'As Is', value: 'AS_IS' },
];

export const containerImageTypes = [
  { label: 'All', value: 'all' },
  { label: 'Has Images', value: 'hasImages' },
  { label: 'No Images', value: 'noImages' },
];

export const containerContents = [
  { label: 'empty', value: 'empty' },
  { label: 'loaded', value: 'loaded' },
];

export const containerLocationTypes = [
  { label: 'All', value: 'all' },
  { label: 'Has Location', value: 'true' },
  { label: 'No Location', value: 'false' },
];

export const tiers = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
  { label: '6', value: 6 },
  { label: '7', value: 7 },
  { label: '8', value: 8 },
  { label: '9', value: 9 },
  { label: '10', value: 10 },
  { label: '11', value: 11 },
  { label: '12', value: 12 },
  { label: '13', value: 13 },
  { label: '14', value: 14 },
  { label: '15', value: 15 },
  { label: '16', value: 16 },
  { label: '17', value: 17 },
  { label: '18', value: 18 },
  { label: '19', value: 19 },
  { label: '20', value: 20 },
];

export const optionalTiers = [{ label: 'On Top', value: '' }, ...tiers];

export const currencyOptions: { label: string; value: CurrencyCode }[] = [
  { label: 'USD: $', value: 'USD' },
  { label: 'EUR: €', value: 'EUR' },
  { label: 'RUB: ₽', value: 'RUB' },
  { label: 'UZS: SUM', value: 'UZS' },
  { label: 'TRY: ₺', value: 'TRY' },
  { label: 'KZT: ₸', value: 'KZT' },
];

export const CURRENCIES = {
  USD: { symbol: '$' },
  EUR: { symbol: '€' },
  RUB: { symbol: '₽' },
  UZS: { symbol: 'SUM' },
  TRY: { symbol: '₺' },
  KZT: { symbol: '₸' },
};